export const globalContent = {
  demoUrl: "https://demo.pulseom.co.uk/login",

  seo: {
    home: {
      title: "Pulse O&M | Digital Building Information Platform",
      description:
        "Bring building documents, drawings, asset information and O&M manuals together in one secure, searchable platform. Make technical building information easier to find and use.",
      canonical: "https://www.pulseom.co.uk/",
    },

    about: {
      title: "About Pulse | Digital Building Information",
      description:
        "Discover how Pulse helps building owners, facilities teams and engineers organise and access building information throughout a building's operational life.",
      canonical: "https://www.pulseom.co.uk/about",
    },

    digitalBuildingInformation: {
      title: "Digital Building Information Platform | Pulse",
      description:
        "Bring building documents, drawings, asset records and technical information together in one secure platform. Give facilities teams a more organised way to access building information.",
      canonical: "https://www.pulseom.co.uk/digital-building-information",
    },

    digitalOm: {
      title: "Digital O&M Manuals | Searchable O&M Information | Pulse",
      description:
        "Make building operation and maintenance information easier to access. Pulse organises O&M manuals, technical documents, drawings and asset records in a searchable digital platform.",
      canonical: "https://www.pulseom.co.uk/digital-om",
    },

    documentsDrawings: {
      title: "Building Document & Drawing Management | Pulse",
      description:
        "Organise and search commercial building documents, technical drawings and supporting records in one place. Give your team easier access to the information they need.",
      canonical: "https://www.pulseom.co.uk/documents-drawings",
    },

    assetInformation: {
      title: "Building Asset Information Management | Pulse",
      description:
        "Connect building assets with their associated manuals, technical drawings, datasheets, warranties and other records in one searchable information platform.",
      canonical: "https://www.pulseom.co.uk/asset-information",
    },

    search: {
      title: "Building Document Search | Pulse",
      description:
        "Find technical building documents, drawings, asset information and records through a central search experience designed for building information.",
      canonical: "https://www.pulseom.co.uk/search",
    },

    ai: {
      title: "AI for Building Information | Pulse",
      description:
        "Explore how AI can help users find answers within building documentation and navigate to relevant source records, where supported by the available information.",
      canonical: "https://www.pulseom.co.uk/ai",
    },

    whoItsFor: {
      title: "Building Information for Owners & Facilities Teams | Pulse",
      description:
        "Discover how building owners, facilities managers, engineers and O&M partners can use Pulse to access and organise building information.",
      canonical: "https://www.pulseom.co.uk/who-its-for",
    },

    resources: {
      title: "Building Information & O&M Guides | Pulse",
      description:
        "Practical guides to digital O&M manuals, building handover information, asset records and managing technical building documentation.",
      canonical: "https://www.pulseom.co.uk/resources",
    },

    requestDemo: {
      title: "Request a Demo | Pulse Building Information Platform",
      description:
        "See how Pulse brings building documents, drawings, asset information and O&M manuals together in a secure, searchable platform. Request a demonstration.",
      canonical: "https://www.pulseom.co.uk/request-a-demo",
    },

    contact: {
      title: "Contact Pulse | Building Information Platform",
      description:
        "Contact Pulse to discuss digital building information, O&M documentation and how the platform could support your organisation.",
      canonical: "https://www.pulseom.co.uk/contact",
    },

    terms: {
      title: "Terms & Conditions | Pulse",
      description:
        "Read the terms and conditions governing your use of the Pulse website.",
      canonical: "https://www.pulseom.co.uk/terms-and-conditions",
    },

    privacy: {
      title: "Privacy Policy | Pulse",
      description:
        "Read the Pulse privacy policy to understand how we collect, use and protect personal information when you use our website.",
      canonical: "https://www.pulseom.co.uk/privacy-policy",
    },

    cookies: {
      title: "Cookie Policy | Pulse",
      description:
        "Learn how Pulse uses cookies and similar technologies on its website.",
      canonical: "https://www.pulseom.co.uk/cookie-policy",
    },

    notFound: {
      title: "Page Not Found | Pulse",
      description:
        "The requested page could not be found. Explore Pulse's digital building information platform or request a demonstration.",
      canonical: "https://www.pulseom.co.uk/404",
    },
  },

  contact: {
    email: "info@pulseom.co.uk",
  },
};
